@import "../../../globalStyles/commons";

:host {
  display: inline-block;
}
